import { useLocation } from 'react-router-dom'
import { extractLocaleFromPath } from '@/lib/routes'

export function useLocale() {
  const { pathname } = useLocation()
  const { locale } = extractLocaleFromPath(pathname)
  return locale
}
